import { getTrackingArray } from 'modules/ensighten_tracking/constants/ensightenConstants';

export const trackPageview = ({ mergedData }) => {
  getTrackingArray().push({ type: 'pageview', data: mergedData });
};
